import React, { useEffect, useState } from 'react';
import configData from '../../../temp/config';
import { withTranslation } from 'react-i18next';
import './ParentOneEyeDropDown.css';

const ParentOneEyeDropDown = (props) => {
    const [showItems, setShowItems] = useState(false)
    const [defaultColor, setDefaultColor] = useState(props.defaultSelectedColor);
    const [eyeColorCode, setEyeColorCode] = useState('')
    const { t } = props;

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        if (props.defaultSelectedColor !== 'Select Color') {
            let image = props.componentData.eyeColorList.filter((item, index) => {
                if (props.defaultSelectedColor.toLowerCase() === item.fields.colorName.value.toLowerCase()) {
                    return item
                }
            })
            if (image.length > 0) {
                setEyeColorCode(image[0].fields.colorCodeHexa.value)
            }
        }
        // props.getSearchType(props.searchTypes[0].fields)
        setDefaultColor(props.defaultSelectedColor === '' ? 'Select Color' : props.defaultSelectedColor)
    }, [])
    const handleClickOutside = (event) => {
        // console.log(event.target.className)
        if (event.target.className === 'slect-box-selected-item-text-div-close' || event.target.className === 'slect-box-selected-item-text-faded' ||
            event.target.className === 'select-box--arrow-up fa fa-angle-up') {
            setShowItems(true)
        }
        // if (event.target.className === 'select-box--selected-item' && document.getElementsByClassName('select-box--arrow-down')[0] !== undefined) {
        //     setShowItems(true)
        // }
        else if (event.target.className === 'select-box--arrow-down') {
            setShowItems(false)
        }
        else if (event.target.className === 'select-box--arrow-up') {
            setShowItems(true)
        } else {
            setShowItems(false)
        }
        // if(event.target.className === 'select-box--selected-item opened') setShowItems(true)

    }


    const dropDown = () => {
        showItems ? setShowItems(false) : setShowItems(true)
    }

    const closeDropDown = () => {
        setShowItems(false)
    }

    const selectItem = (item) => {
        setEyeColorCode(item.fields.colorCodeHexa.value)
        setDefaultColor(item.fields.colorName.value)
        setShowItems(false)
        props.sendMotherColor(item)
    }

    return (
        <div className="nameSearchFieldDropdown">
            <div className="custom-select-dropdown">

                <div className="select-box--box">
                    <div className="select-box--container"  >
                        <div className={"select-box--selected-item"} onClick={dropDown}>
                            <div className={!showItems ? "slect-box-selected-item-text-div" : 'slect-box-selected-item-text-div-close'} >
                                {defaultColor !== 'Select Color' && <i className="fa fa-eye gender-img" style={{ color: eyeColorCode }}></i>}
                                <span className={defaultColor === 'Select Color' ? "slect-box-selected-item-text-faded" : "slect-box-selected-item-text"}>{defaultColor}</span>
                            </div>
                            <div className="select-box--arrow" name="select-box--name">
                                <span name="drop-down-arrow" className={`${showItems ? 'select-box--arrow-up fa fa-angle-up' : 'select-box--arrow-down fa fa-angle-down'}`}>
                                </span>
                            </div>
                        </div>
                        <div style={{ display: showItems ? 'block' : 'none' }}
                            className="select-box--items gender-month-wrapper"
                        >
                            {
                                props.componentData.eyeColorList.map((item, index) => {
                                    return (
                                        <div className="gender-select-div" key={index} onClick={() => selectItem(item)}>
                                            <i className="fa fa-eye " style={{ color: item.fields.colorCodeHexa.value }}></i>
                                            <p className="nameListItem"> {item.fields.colorName.value} </p>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}



export default withTranslation()(ParentOneEyeDropDown);